import { Table } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { LEGAL_ENTITIES_HEADER, U_KEY } from '@app/constants';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import { getPaginationItemRenderWithDataTestIds } from '@app/utils';

import { useLegalEntities } from '@pages/LegalEntities/LegalEntitiesList/hooks/useLegalEntities';
import { useLegalEntitiesEffects } from '@pages/LegalEntities/LegalEntitiesList/hooks/useLegalEntitiesEffects';

import { adaptDataToTable } from '@pages/LegalEntities/LegalEntitiesList/utils/adaptDataToTable';

import type { FC } from 'react';

import '@pages/LegalEntities/LegalEntitiesList/styles/LegalEntities.scss';

export const LegalEntities: FC = () => {
  const {
    isLoading,
    legalEntities,
    hasUserRightForModuleView,
    hasUserRightToEditLegalEntities,
    handleEdit,
    isMobile,
    handleChange,
    pageNumber,
    rowsPerPage,
    getLegalEntitiesHandler,
  } = useLegalEntities();

  useLegalEntitiesEffects({ getLegalEntitiesHandler });

  if (!hasUserRightForModuleView) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="LegalEntities">
      <Table
        className="LegalEntities__table"
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: 800 }}
        rowKey={(record) => record[U_KEY]}
        rowClassName={({ isDeleted }) =>
          isDeleted ? 'LegalEntities__row--archived' : 'LegalEntities__row'
        }
        loading={isLoading}
        columns={LEGAL_ENTITIES_HEADER}
        dataSource={adaptDataToTable(
          legalEntities,
          hasUserRightToEditLegalEntities,
          handleEdit
        )}
        pagination={{
          itemRender: getPaginationItemRenderWithDataTestIds,
          size: isMobile ? 'small' : 'default',
          showSizeChanger: true,
          showLessItems: isMobile,
          position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
          showTotal: (total, range) =>
            generateSpanWithDataTestId(
              isMobile
                ? `Всего ${total}`
                : `Показаны ${range[0]}-${range[1]} из ${total}`,
              'pagination-info'
            ),
          pageSize: rowsPerPage,
          current: pageNumber,
          onChange: handleChange,
        }}
      />
    </div>
  );
};
